import { Radio } from '@banhala/ui-kit';
import type { FilterType } from '../../../../../api/screensService/getScreensFilterOptions/enums';
import { type SetFilterListBottomSheetViaQueryValueProps } from '../Provider/filterListBottomSheet/useFilterListBottomSheetAtom';
import { RectangleFilterItemBox } from './RectangleFilterItemBox/RectangleFilterItemBox';
import { RectangleFilterItem } from './RectangleFilterItem/RectangleFilterItem';
import { useFilterHeader } from './useFilterHeader';
import { RenderItemWrapper } from './RenderItemWrapper';
import type { SetListHeight } from '../hooks/useListHeight';

interface SingleFilterProps {
  title: string;
  type: FilterType.Single;
  entity: {
    queryName: string;
    selectedQueryValue: string;
    possibleItems: {
      text: string;
      queryValue: string;
    }[];
  };
  handleClickFilter: (
    props: SetFilterListBottomSheetViaQueryValueProps & { title: string },
  ) => void;
  setListHeight: SetListHeight;
  index: number;
}

export const SingleFilter = ({
  title,
  handleClickFilter,
  setListHeight,
  entity: { selectedQueryValue, possibleItems, queryName },
  index,
}: SingleFilterProps) => {
  const { Header } = useFilterHeader({ title });

  return (
    <RenderItemWrapper
      setListHeight={setListHeight}
      index={index}
      title={title}
    >
      <Header />
      <RectangleFilterItemBox>
        {possibleItems.map((item, listIndex) => (
          <RectangleFilterItem
            key={`${title}-${item.queryValue}`}
            testID={`${title}필터?LIST_ID=${listIndex}`}
            isSelected={selectedQueryValue === item.queryValue}
            onPress={() => {
              handleClickFilter({
                queryName,
                queryValue: item.queryValue,
                title,
              });
            }}
          >
            <Radio
              value={selectedQueryValue === item.queryValue}
              label={item.text}
              dotColor="black"
              onPress={() => {
                handleClickFilter({
                  queryName,
                  queryValue: item.queryValue,
                  title,
                });
              }}
            />
          </RectangleFilterItem>
        ))}
      </RectangleFilterItemBox>
    </RenderItemWrapper>
  );
};
